import React, {useEffect} from 'react';
import {Formik, FormikProps} from 'formik';
import {Button, TextInput} from 'ui-kits';
import {View, StyleSheet, ViewStyle, TextStyle} from 'react-native';
import {spacing} from 'theme/Units';
import colors from 'theme/Colors';
import { UpdateProfileValidation } from 'utils/schema';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {RootNavigatorParams, Routes} from 'navigation/Routes';
import {useResponsiveStyles} from 'hooks/useResponsiveStyles';

type propTypes = Readonly<{
  initialValues: {
    personal_email: string;
    phone: string;
  };
  onSubmit: (values: any) => void;
}> &
  NativeStackScreenProps<RootNavigatorParams>;

export function UpdateProfile(props: propTypes) {
  const {initialValues, onSubmit, navigation} = props;

  function handleCancel() {
    navigation.navigate(Routes.VIEW_PROFILE);
  }

  return (
    <Formik initialValues={initialValues} validationSchema={UpdateProfileValidation} onSubmit={onSubmit}>
      {formikProp => (
        <FormComponent
          {...formikProp}
          initialValues={initialValues}
          onCancel={handleCancel}
        />
      )}
    </Formik>
  );
}

type formProps = Readonly<{
  initialValues: propTypes['initialValues'];
  onCancel: () => void;
}> &
  FormikProps<propTypes['initialValues']>;

function FormComponent({
  handleChange,
  handleSubmit,
  values,
  errors,
  dirty,
  isValid,
  setValues,
  initialValues,
  onCancel,
}: formProps) {
  useEffect(() => {
    if (initialValues) {
      // de-serialize the values
      setValues(initialValues);
    }
  }, [initialValues, setValues]);
  const styles = useResponsiveStyles<styleTypes>(baseStyles, responsive);
  return (
    <View style={styles.formContainer}>
      <View style={styles.inputWrapper}>
        <TextInput
          value={values.personal_email}
          error={errors.personal_email}
          label="Personal Email"
          placeholder="Enter Personal Email ID"
          onChangeText={handleChange('personal_email')}
        />

        <TextInput
          value={values.phone}
          label="Phone Number"
          error={errors.phone}
          placeholder="Enter Phone Number"
          type="numeric"
          maxLength={10}
          onChangeText={handleChange('phone')}
        />
      </View>
      {/* Action Buttons */}
      <View style={styles.actionButtonWrapper}>
        <Button text="Cancel" variant="secondary" onPress={onCancel} />
        <Button
          text="Update"
          variant="primary"
          disabled={!dirty || !isValid}
          onPress={handleSubmit}
          textStyle={styles.submitButtonText}
        />
      </View>
    </View>
  );
}
type styleTypes = {
  formContainer: ViewStyle;
  inputWrapper: ViewStyle;
  actionButtonWrapper: ViewStyle;
  submitButtonText: TextStyle;
};
const baseStyles: styleTypes = StyleSheet.create({
  formContainer: {
    gap: spacing['6'],
    maxWidth: 350,
  },
  inputWrapper: {
    gap: spacing['3'],
  },
  actionButtonWrapper: {
    width: '100%',
    flexDirection: 'row',
    gap: spacing['6'],
  },
  submitButtonText: {color: colors.palette.white},
});

const responsive: Record<number, Partial<styleTypes>> = {
  640: StyleSheet.create({
    actionButtonWrapper: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: spacing['3'],
    },
  }),
};
